var React = require('react');

function IconSearch (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.243 12.243a6 6 0 1 0-8.485-8.485 6 6 0 0 0 8.485 8.485zm6.964 5.55c.943.943-.471 2.357-1.414 1.414l-4.887-4.887a8 8 0 1 1 1.414-1.414l4.887 4.887z","fillRule":"evenodd"}));
}

IconSearch.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = IconSearch;

IconSearch.default = IconSearch;
